export default "__VITE_ASSET__4c6655be__"